export const CUSTOM_LABELS_JSON_TEMPLATE = [
    'membership_and_passes_label',
]